import { DOCUMENT } from '@angular/common';
import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlatformContextService } from '@shared/services/platform-context';
import { filter, fromEvent, Observable, retry, take, throwError } from 'rxjs';

/** Marks a POST that only reads (an Elasticsearch search) as safe to send twice, as every GET is. */
export const RETRY_WHEN_VISIBLE = new HttpContextToken<boolean>(() => false);

@Injectable()
export class RetryWhenVisibleInterceptor implements HttpInterceptor {
  private readonly document = inject(DOCUMENT);
  private readonly platformContextService = inject(PlatformContextService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.platformContextService.isServer() || (req.method !== 'GET' && !req.context.get(RETRY_WHEN_VISIBLE)))
      return next.handle(req);
    return next.handle(req).pipe(
      retry({
        count: 1,
        delay: (error: unknown) =>
          error instanceof HttpErrorResponse && error.status === 0 && this.document.visibilityState === 'hidden'
            ? fromEvent(this.document, 'visibilitychange').pipe(
                filter(() => this.document.visibilityState === 'visible'),
                take(1)
              )
            : throwError(() => error),
      })
    );
  }
}
